export default __webpack_public_path__ + "static/media/bg-ball2.f6d365d5.png";